import { BasePage } from '@/components/ui/base-page'

export function CreditosnPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add CreditosnPage specific content here */}
    </BasePage>
  )
}